module.exports = __webpack_public_path__ + "static/media/icon_add.312bd29e.svg";